const createExternalStore = (initialState) => {
  let state = initialState;
  const listeners = /* @__PURE__ */ new Set();
  return {
    getState: () => state,
    setState: (next) => {
      if (Object.entries(next).every(([key, value]) => Object.is(state[key], value))) {
        return;
      }
      state = { ...state, ...next };
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
};
export default createExternalStore;
